interface Props {
  [key: string]: any
}

function GeogebraIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 450 450" {...rest} xmlns="http://www.w3.org/2000/svg">
      <defs className={pathClassName ?? ''} id="defs4">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath3092">
          <path d="M 0,0 440,0 440,120 0,120 0,0 z" id="path3094" />
        </clipPath>
      </defs>
      <g className={pathClassName ?? ''} id="layer1" transform="translate(-40,-565)">
        <g id="g3088" transform="matrix(8.6883434,0,0,-8.6883434,-1556.5077,1274.3718)" />
        <g id="g3926" transform="matrix(1.0616291,0,0,1.0332278,-21.328835,-14.377521)">
          <g id="g2992">
            <path
              d="m 432.34528,250.87556 c 0,87.31008 -75.9798,158.08887 -169.70563,158.08887 -93.72583,0 -169.705629,-70.77879 -169.705629,-158.08887 0,-87.31007 75.979799,-158.088863 169.705629,-158.088863 93.72583,0 169.70563,70.778793 169.70563,158.088863 z"
              fill="none"
              id="path3923"
              stroke="#666666"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="33.33686066"
              transform="matrix(0.95664986,0.01344252,-0.18982336,0.96049072,60.522811,545.36887)"
            />
            <path
              d="m 644.28569,145.57143 c 0,26.43077 -20.78678,47.85714 -46.42857,47.85714 -25.64179,0 -46.42857,-21.42637 -46.42857,-47.85714 0,-26.43077 20.78678,-47.857147 46.42857,-47.857147 25.64179,0 46.42857,21.426377 46.42857,47.857147 z"
              fill="#9999ff"
              fillRule="nonzero"
              id="path3042-0"
              stroke="#000000"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="15.55358315"
              transform="matrix(0.91220639,0,0,0.88497633,-192.4036,771.88746)"
            />
            <path
              d="m 644.28569,145.57143 c 0,26.43077 -20.78678,47.85714 -46.42857,47.85714 -25.64179,0 -46.42857,-21.42637 -46.42857,-47.85714 0,-26.43077 20.78678,-47.857147 46.42857,-47.857147 25.64179,0 46.42857,21.426377 46.42857,47.857147 z"
              fill="#9999ff"
              fillRule="nonzero"
              id="path3042-0-9"
              stroke="#000000"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="15.55358315"
              transform="matrix(0.91220639,0,0,0.88497633,-122.25615,606.5878)"
            />
            <path
              d="m 644.28569,145.57143 c 0,26.43077 -20.78678,47.85714 -46.42857,47.85714 -25.64179,0 -46.42857,-21.42637 -46.42857,-47.85714 0,-26.43077 20.78678,-47.857147 46.42857,-47.857147 25.64179,0 46.42857,21.426377 46.42857,47.857147 z"
              fill="#9999ff"
              fillRule="nonzero"
              id="path3042-0-4"
              stroke="#000000"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="15.55358315"
              transform="matrix(0.91220639,0,0,0.88497633,-376.74275,794.90043)"
            />
            <path
              d="m 644.28569,145.57143 c 0,26.43077 -20.78678,47.85714 -46.42857,47.85714 -25.64179,0 -46.42857,-21.42637 -46.42857,-47.85714 0,-26.43077 20.78678,-47.857147 46.42857,-47.857147 25.64179,0 46.42857,21.426377 46.42857,47.857147 z"
              fill="#9999ff"
              fillRule="nonzero"
              id="path3042-0-8"
              stroke="#000000"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="15.55358315"
              transform="matrix(0.91220639,0,0,0.88497633,-435.46543,634.0343)"
            />
            <path
              d="m 644.28569,145.57143 c 0,26.43077 -20.78678,47.85714 -46.42857,47.85714 -25.64179,0 -46.42857,-21.42637 -46.42857,-47.85714 0,-26.43077 20.78678,-47.857147 46.42857,-47.857147 25.64179,0 46.42857,21.426377 46.42857,47.857147 z"
              fill="#9999ff"
              fillRule="nonzero"
              id="path3042-0-82"
              stroke="#000000"
              strokeDasharray="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={4}
              strokeWidth="15.55358315"
              transform="matrix(0.91220639,0,0,0.88497633,-289.85913,514.01166)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default GeogebraIcon
